export default __webpack_public_path__ + "static/media/carpetinstallation.ed0b3f96.jpg";